import { DISMISS_ERROR } from "./types";

export function dismissErrors() {
	return {
		type: DISMISS_ERROR
	};
}
